import api from "../../index";

export const GetSalesDashboardApi = (params) =>
  api.get(`SalesDashboard/Get-Sales-Lead-Dashboard?${params}`);

export const GetSalesReportApi = (params) =>
  api.get(`Sales/sales-report?${params}`);

export const GetSalesDepositTrendsApi = (params) =>
  api.get(`Sales/deposit-trends?${params}`);

export const GetSalesSourceMixApi = (params) =>
  api.get(`Sales/source-mix?${params}`);

export const GetTopPerformingAgentsApi = (params) =>
  api.get(`Sales/top-performing-agents?${params}`);

export const GetTopPerformingTeamLeadersApi = (params) =>
  api.get(`Sales/top-performing-team-leaders?${params}`);

export const GetAssignedSalesOfficeApi = () =>
  api.get("Sales/office/assigned");

export const GetSalesAgentsApi = (params) =>
  api.get("Sales/salesagent/get-all", { params });

export const buildSalesAgentsParams = ({ teamLeadId, agentId }) => {
  const params = { teamLeadId };
  // if (agentId) params.salesAgentId = agentId;
  return params;
};

export const mapSalesAgentsToOptions = (payload) =>
  (payload?.salesAgents || []).map((item) => ({
    label: item?.fullName || item?.agentName,
    value: item?.userId || item?.agentId,
  }));